import React from 'react';
import Modal from '@/components/Modal';
import Button from '@/components/Button';
import { batchOverviewModal, rejectPaymentModal } from '@/utils/translations';

interface MarkAsCompleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
  error?: string | null;
}

const MarkAsCompleteConfirmModal: React.FC<MarkAsCompleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
  error
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    headerText={batchOverviewModal.markAsCompleteConfirmTitle}
    headerVariant="xxl-medium">
    <div className="flex flex-col gap-y-6 py-4">
      <p className="text-sm font-medium text-emerge-navy">
        {batchOverviewModal.markAsCompleteConfirmBody}
      </p>

      {error && (
        <p role="alert" className="text-xs font-medium text-error-darkred">
          {error}
        </p>
      )}

      <div className="flex items-center justify-center gap-x-5">
        <Button size="pill" className="w-[140px]" disabled={isSubmitting} onClick={onConfirm}>
          {isSubmitting
            ? batchOverviewModal.markingAsCompleteButton
            : batchOverviewModal.markAsCompleteButton}
        </Button>
        <Button
          variant="primary_inverted"
          size="pill"
          className="w-[140px] border-aux-gray"
          disabled={isSubmitting}
          onClick={onClose}>
          {rejectPaymentModal.cancelButton}
        </Button>
      </div>
    </div>
  </Modal>
);

export default MarkAsCompleteConfirmModal;
